/* eslint-disable react/no-unescaped-entities */
import React from "react";
import { Link } from "react-router-dom";
import { Wordmark, SmileMark } from "../brand/Brand";
import AppStoreBadges from "../brand/AppStoreBadges";
import { scrollToId } from "../../hooks/useLenis";

const navLinks = [
  { id: "le-concept", label: "Le concept" },
  { id: "nos-services", label: "Nos services" },
  { id: "tracabilite", label: "Traçabilité" },
  { id: "le-reseau", label: "Le réseau" },
  { id: "devenir-diallo", label: "Devenir Diallo" },
];

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="relative bg-diallo-charcoal text-white">
      <div className="mx-auto max-w-7xl px-5 md:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
          <div className="md:col-span-1">
            <Wordmark variant="white" className="h-10" />
            <p className="mt-4 font-display italic text-lg text-white/80">« Le quartier me connaît. »</p>
            <div className="mt-5">
              <SmileMark color="#ED1C24" size={48} strokeWidth={6} />
            </div>
            <p className="mt-6 text-sm font-semibold text-white/80">Téléchargez l'application</p>
            <AppStoreBadges className="mt-3" onDark />
          </div>

          <div>
            <h4 className="font-display font-semibold text-white/60 text-sm uppercase tracking-widest">Naviguer</h4>
            <ul className="mt-4 space-y-2.5">
              {navLinks.map((l) => (
                <li key={l.id}>
                  <button
                    onClick={() => scrollToId(l.id)}
                    data-testid={`footer-link-${l.id}`}
                    className="text-white/80 transition-colors hover:text-diallo-red"
                  >
                    {l.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-display font-semibold text-white/60 text-sm uppercase tracking-widest">Informations</h4>
            <ul className="mt-4 space-y-2.5">
              <li>
                <Link to="/mentions-legales" data-testid="footer-mentions-legales" className="text-white/80 transition-colors hover:text-diallo-red">
                  Mentions légales
                </Link>
              </li>
              <li>
                <Link to="/confidentialite" data-testid="footer-confidentialite" className="text-white/80 transition-colors hover:text-diallo-red">
                  Confidentialité
                </Link>
              </li>
              <li>
                <button onClick={() => scrollToId("devenir-diallo")} className="text-white/80 transition-colors hover:text-diallo-red">
                  Nous contacter
                </button>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 text-sm text-white/55">
          <p>© {new Date().getFullYear()} Diallo — un projet Océana Groupe.</p>
          <p>Avec l'appui de Smartworld.</p>
        </div>
      </div>
    </footer>
  );
}
